import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

var Radio = (_param)=>{
    var { children , className  } = _param, htmlInputProps = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React__default.createElement("label", {
        className: classnames('radio', className)
    }, /*#__PURE__*/ React__default.createElement("input", swcHelpers.extends({
        type: "radio",
        className: "radio__input"
    }, htmlInputProps)), children);
};

export { Radio };
//# sourceMappingURL=Radio.js.map
